import { Select } from '@/components/ui';
import { QuestionWrapper } from './question-wrapper';
import type { QuestionComponentProps } from '@/types';

export function Dropdown({
  question,
  value,
  onChange,
  disabled,
  errors,
  displayOrder,
}: QuestionComponentProps<string | null>) {
  const options = question.config?.options || [];
  const placeholder = question.config?.placeholder || 'Please select...';

  // Apply display order if provided
  const orderedOptions = displayOrder
    ? displayOrder.map((i) => options[i]).filter(Boolean)
    : options;

  const selectOptions = orderedOptions.map((opt) => ({
    value: opt.value,
    label: opt.text,
  }));

  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const newValue = e.target.value;
    onChange(newValue || null);
  };

  return (
    <QuestionWrapper question={question} errors={errors}>
      <Select
        options={selectOptions}
        placeholder={placeholder}
        value={value || ''}
        onChange={handleChange}
        disabled={disabled}
        hasError={!!errors?.length}
        className="max-w-md"
      />
    </QuestionWrapper>
  );
}
